module.exports = __webpack_public_path__ + "bitmap.png?0d08cf3354941e108f27410b8ad59079";